/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import InputRegex from '../InputRegex';
import round from '~/utils/Number/round';

const getMask = (precision, integerLimit = 4) => {
  return createNumberMask({
    thousandsSeparatorSymbol: '.',
    decimalSymbol: precision > 0 ? ',' : '',
    decimalLimit: precision,
    includeThousandsSeparator: true,
    allowDecimal: true,
    requireDecimal: true,
    allowNegative: true,
    allowLeadingZeroes: true,
    prefix: '',
    suffix: '',
    integerLimit: integerLimit
  });
};

function inputValueToFloat(event) {
  return parseFloat(event.target.value.replace(/\./g, '').replace(/,/g, '.'));
}

class InputReais extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.oneOf([null]),
      PropTypes.string,
      PropTypes.number,
    ]),
    precision: PropTypes.number.isRequired,
    integerLimit: PropTypes.number,
    config: PropTypes.object,
    valueType: PropTypes.oneOf(['numeric', 'string']),
  };

  static getDerivedStateFromProps(nextProps) {
    return { mask: getMask(nextProps.precision, nextProps.integerLimit) };
  }

  static defaultProps = {
    precision: 2,
    integerLimit: 4,
    config: {},
    valueType: 'numeric',
  };

  state = {
    mask: '',
    hasFocused: false, // Track focus state
  };

  handleChange = (event) => {
    const {
      onChange,
      precision,
      'state-name': stateName,
      valueType,
    } = this.props;

    let { value } = event.target;
    if (value !== '' && valueType === 'numeric') {
      value = round(inputValueToFloat(event), precision);
    }

    if (value === '') {
      value = null;
    }

    onChange({ [stateName]: value }, event);
  };

  onKeyDown = (event) => {
    const keyCode = Number(event.keyCode);
    const config = this.props.config;
    const allowNegative = (config || {}).allowNegative;

    if (allowNegative !== false && (keyCode === 109 || keyCode === 189)) {
      event.preventDefault();
      const {
        onChange,
        precision,
        'state-name': stateName,
        valueType,
      } = this.props;
      const number = round(inputValueToFloat(event), precision) * -1;

      onChange(
        { [stateName]: valueType === 'numeric' ? number : String(number) },
        event
      );
    }
  };

  onSelect = (event) => {
    if (!this.state.hasFocused) {
      event.target.select();
      this.setState({ hasFocused: true }); // Update focus state
    }
  };

  inputValueFormat = () => {
    const { value } = this.props;
    if (typeof value === 'undefined') {
      return value;
    } else if (value === null || value === '') {
      return '';
    }
    return value.toString().replace(/\./g, ',');
  };

  render() {
    const {
      precision,
      integerLimit,
      onChange,
      config,
      value,
      inputProps,
      valueType,
      ...otherProps
    } = this.props;
    return (
      <InputRegex
        {...otherProps}
        value={this.inputValueFormat()}
        onChange={this.handleChange}
        onKeyDown={this.onKeyDown}
        onSelect={this.onSelect}
        mask={this.state.mask}
        inputProps={{
          ...inputProps,
          inputMode: 'numeric',
        }}
      />
    );
  }
}

export default InputReais;
